import {Pipe, PipeTransform} from '@angular/core';
import {orderBy} from 'lodash';


@Pipe({
  name: 'OrderBy'
})

export class OrderByPipe implements PipeTransform {
  transform(array: any[], field: string): any[] {
    if (!Array.isArray(array) || array.length <= 1) {
      return array;
    }

    array.sort((a, b) => {
      const aValue = a[field];
      const bValue = b[field];

      if (aValue < bValue) {
        return -1;
      } else if (aValue > bValue) {
        return 1;
      } else {
        return 0;
      }
    });

    return array;
  }


}



// WEBPACK FOOTER //
// ./src/app/pipe/order.pipe.ts